import React, { useRef } from 'react';
import { toastr } from 'react-redux-toastr';

import Icon from 'xpi-black-ui/Base/Icon';
import { Row } from 'xpi-black-ui/Base/Grid';
import Button from 'xpi-black-ui/Base/Button';
import KeyValue from 'xpi-black-ui/Common/KeyValue';
import ContentDivider from 'xpi-black-ui/Common/ContentDivider';
import Table, { Thead, Tbody, Tr, Th } from 'xpi-black-ui/Common/Table';

import Leg from './Leg';

import waConfig from 'utils/waConfig';

import { Container, Quote } from './styles';

function Quotes({ quotes, editQuote, deleteQuote }) {
  const inputHidden = useRef();

  const onCopyQuote = (id) =>{
    window.getSelection()
      .selectAllChildren(document.getElementById(id));

    document.execCommand('copy');
    inputHidden.current.click();
    toastr.info('Cotação personalizada copiada com sucesso');
  };

  const undoSelectWindow = () => {
    window.getSelection().selectAllChildren(document.getElementById('inputHidden'));
  };

  return (
    <Container>
      <input type="hidden" ref={inputHidden} onClick={() => undoSelectWindow()} id="inputHidden"/>
      {quotes.map(quote => (
        <Quote key={quote.id}>
          <div id={quote.id}>
            <p className="text-invisible">Cotação Personalizada Black</p>
            <Row>
              <ContentDivider>
                <KeyValue title="Nome da cotação:" value={<><span>&nbsp;</span>{quote?.nomeEstrutura}</>} style={{ alignItems: 'center' }} />
              </ContentDivider>
              <ContentDivider>
                <KeyValue title="Data da cotação:" value={<><span>&nbsp;</span>{quote?.data}</>} style={{ alignItems: 'center' }} />
              </ContentDivider>
            </Row>
            <Table>
              <Thead>
                <Tr>
                  <Th width="80px">Ativo</Th>
                  <Th width="80px">Spot</Th>
                  <Th width="80px">Natureza</Th>
                  <Th width="80px">Quantidade</Th>
                  <Th width="80px">Tipo</Th>
                  <Th width="80px">Vencimento</Th>
                  <Th width="80px">Strike R$</Th>
                  <Th width="80px">Strike %</Th>
                </Tr>
              </Thead>
              <Tbody>
                {quote?.vertices.map((leg, index) => (
                  <Leg key={leg.asset+index} leg={leg} />
                ))}
              </Tbody>
            </Table>

            <Row justifyContent="space-between" className="price">
              <KeyValue title="Preço indicativo:" value={<><span>&nbsp;</span>{quote?.indicativePriceFormatted}</>} style={{ alignItems: 'center' }} />
              <KeyValue title="Comissão:" value={<><span>&nbsp;</span>{quote?.commissionFormatted}</>} style={{ alignItems: 'center' }} />
              <KeyValue title="Preço operação:" value={<><span>&nbsp;</span>{quote?.endPriceFormatted}</>} style={{ alignItems: 'center' }} />
            </Row>
          </div>

          <Row justifyContent="space-between" className="buttons" style={{ marginLeft: '16px', width:'205px' }}>
            <Button onClick={() => onCopyQuote(quote.id)} data-wa={waConfig.event.customQuotes.copy}>Copiar cotação</Button>
            <Icon type="edit" onClick={() => editQuote(quote)} data-wa={waConfig.event.customQuotes.edit} style={{ margin: '0 16px' }} />
            <Icon type="delete" onClick={() => deleteQuote(quote)} data-wa={waConfig.event.customQuotes.delete} />
          </Row>
        </Quote>
      ))}
    </Container>
  );
}

export default Quotes;
